import styled from '@emotion/styled'

import { HeadingXS } from '@/components/Typography'
import { CONFIG } from '@/styles/emotion.config'

export const MediaCardListSection = styled.section`
  max-width: ${CONFIG.maxWidths.md};
  margin: 0 auto;
  padding: 5rem 0;

  ${CONFIG.media.mobileLg} {
    padding: 2.5rem 1rem;
  }
`

export const MediaCardListHeader = styled.header`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const MediaCardList = styled.ul`
  margin-top: 2rem;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`

export const MediaCardListItem = styled.li`
  background: #fff;
  border: ${CONFIG.theme.borders.lightGray};
  box-shadow: ${CONFIG.theme.shadows.lightGray};
  border-radius: ${CONFIG.theme.radii.default};
  padding: 1rem;
  width: 100%;
  max-width: ${CONFIG.maxWidths.sm};
`

export const MediaCardListItemHeader = styled.header`
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-bottom: 1rem;
`

export const MediaCardHeading = styled(HeadingXS)`
  max-width: calc(100% - 4rem);
`
